export default {
  report: state => state.invoice,

  loading: state => state.loading,
  error: state => state.error,
  dailyRevenueError: state => state.dailyRevenueError,
  cogsError: state => state.cogsError,
  incomingInvoicesError: state => state.incomingInvoicesError,
  message: state => state.message,
  cogsMessage: state => state.cogsMessage,
  incomingInvoicesMessage: state => state.incomingInvoicesMessage,
  dailyRevenueMessage: state => state.dailyRevenueMessage
}